// @ts-nocheck
import withGoogleTag from '../../Analytics/GTag/withGoogleTag'
import CreatePage from './CreatePage'

const CreatePageWithGoogleTag = withGoogleTag(CreatePage)

export default CreatePageWithGoogleTag
